import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const GET_SALON_ONLINE_SETTINGS_REQUEST = 'GET_SALON_ONLINE_SETTINGS_REQUEST';
export const GET_SALON_ONLINE_SETTINGS_SUCCESS = 'GET_SALON_ONLINE_SETTINGS_SUCCESS';
export const GET_SALON_ONLINE_SETTINGS_FAILURE = 'GET_SALON_ONLINE_SETTINGS_FAILURE';
export const CHANGE_PATCH_TEST = 'CHANGE_PATCH_TEST';
export const CHANGE_IS_OPEN = 'CHANGE_IS_OPEN';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const CHANGE_IS_ONLINE = 'CHANGE_IS_ONLINE';
export const STYLIST_CATEGORY_CHANGE_IS_ONLINE = 'STYLIST_CATEGORY_CHANGE_IS_ONLINE';
export const SAVE_SALON_ONLINE_SETTINGS_REQUEST = 'SAVE_SALON_ONLINE_SETTINGS_REQUEST';
export const SAVE_SALON_ONLINE_SETTINGS_SUCCESS = 'SAVE_SALON_ONLINE_SETTINGS_SUCCESS';
export const SAVE_SALON_ONLINE_SETTINGS_FAILURE = 'SAVE_SALON_ONLINE_SETTINGS_FAILURE';
export const TOGGLE_EVERYTHING_OFFLINE = 'TOGGLE_EVERYTHING_OFFLINE';
export const RESTORE_SERVER_DATA = 'RESTORE_SERVER_DATA';
export const CLEAR_COMPLETED_SAVE_SETTINGS = 'CLEAR_COMPLETED_SAVE_SETTINGS';
export const SET_NOSHOW_OR_DEPOSIT_REQUEST = 'SET_NOSHOW_OR_DEPOSIT_REQUEST';
export const SET_NOSHOW_OR_DEPOSIT_SUCCESS = 'SET_NOSHOW_OR_DEPOSIT_SUCCESS';
export const SET_NOSHOW_OR_DEPOSIT_FAILURE = 'SET_NOSHOW_OR_DEPOSIT_FAILURE';
export const GET_SALON_STRIPE_DASHBOARD_REQUEST = 'GET_SALON_STRIPE_DASHBOARD_REQUEST';
export const GET_SALON_STRIPE_DASHBOARD_SUCCESS = 'GET_SALON_STRIPE_DASHBOARD_SUCCESS';
export const GET_SALON_STRIPE_DASHBOARD_FAILURE = 'GET_SALON_STRIPE_DASHBOARD_FAILURE';

export const getSalonOnlineSettings = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `settings/onlinebooking/${salonId}/`,
    authenticated: true,
    types: [GET_SALON_ONLINE_SETTINGS_REQUEST, GET_SALON_ONLINE_SETTINGS_SUCCESS, GET_SALON_ONLINE_SETTINGS_FAILURE],
  },
});

export const saveSalonOnlineSettings = (salonId, data, serverData, on) => {
  let serviceOnline = false;

  const dto = {
    stylist_service_data: {},
    business_hours: {},
    patch_test: {},
    online_booking: false,
  };

  const stylistIds = Object.keys(data.stylist_service_data);

  for (let i = 0; i < stylistIds.length; i += 1) {
    //
    const stylistId = stylistIds[i];
    const stylist = data.stylist_service_data[stylistId];
    const serverStylist = serverData.stylist_service_data[stylistId];
    const categoryIds = Object.keys(stylist.categories);

    for (let j = 0; j < categoryIds.length; j += 1) {
      //
      const category = stylist.categories[categoryIds[j]];
      const serverCategory = serverStylist.categories[categoryIds[j]];

      for (let k = 0; k < category.length; k += 1) {
        //
        const service = category[k];
        const serverService = serverCategory[k];

        if (service.is_online !== serverService.is_online) {
          if (!dto.stylist_service_data[stylistId]) dto.stylist_service_data[stylistId] = {};
          dto.stylist_service_data[stylistId][service.service_id.toString()] = { is_online: service.is_online };
        }

        if (service.is_online) serviceOnline = true;
      } // for k
    } // for j
  } // for i

  const days = Object.keys(data.business_hours);
  let dayOnline = false;

  for (let i = 0; i < days.length; i += 1) {
    //
    const day = data.business_hours[days[i]];
    const serverDay = serverData.business_hours[days[i]];

    if (day && serverDay && day.is_open !== serverDay.is_open) {
      dto.business_hours[days[i]] = { is_open: day.is_open };
    }

    if (day && day.is_open) dayOnline = true;
  } // for i

  for (let i = 0; i < data.category_services.length; i += 1) {
    //
    const category = data.category_services[i];
    const serverCategory = serverData.category_services[i];

    for (let j = 0; j < category.services.length; j += 1) {
      //
      const service = category.services[j];
      const serverService = serverCategory.services[j];

      if (service.patch_test !== serverService.patch_test) {
        dto.patch_test[service.id.toString()] = { has_patch_test: service.patch_test };
      }
    } // for j
  } // for i

  dto.online_booking = on;

  // NOTE: generate the body before the following deletions of required fields
  const body = JSON.stringify(dto);

  if (Object.keys(dto.business_hours).length === 0) delete dto.business_hours;
  if (Object.keys(dto.stylist_service_data).length === 0) delete dto.stylist_service_data;
  if (Object.keys(dto.patch_test).length === 0) delete dto.patch_test;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `settings/onlinebooking/${salonId}/`,
      authenticated: true,
      types: [
        SAVE_SALON_ONLINE_SETTINGS_REQUEST,
        SAVE_SALON_ONLINE_SETTINGS_SUCCESS,
        SAVE_SALON_ONLINE_SETTINGS_FAILURE,
      ],
      config: {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body,
      },
      params: dto,
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: dayOnline && serviceOnline ? 'NCOBEnabled' : 'NCOBDisabled',
          properties: { enabled: dayOnline && serviceOnline, salonId },
        },
      },
    },
  };
};

export const clearErrorMessage = () => ({ type: CLEAR_ERROR_MESSAGE, meta: { analytics: EventTypes.track } });

export function changePatchTest(id, value) {
  return {
    type: CHANGE_PATCH_TEST,
    id,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function changeIsOpen(day, value) {
  return {
    type: CHANGE_IS_OPEN,
    day,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function changeIsOnline(stylistId, serviceId, value) {
  return {
    type: CHANGE_IS_ONLINE,
    stylistId,
    serviceId,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function stylistCategoryChangeIsOnline(stylistId, categoryName, value) {
  return {
    type: STYLIST_CATEGORY_CHANGE_IS_ONLINE,
    stylistId,
    categoryName,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function toggleEverythingOffline(on, dayService) {
  return {
    type: TOGGLE_EVERYTHING_OFFLINE,
    on,
    dayService,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function restoreServerData() {
  return {
    type: RESTORE_SERVER_DATA,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export const clearCompletedSaveSettings = () => ({
  type: CLEAR_COMPLETED_SAVE_SETTINGS,
  meta: { analytics: EventTypes.track },
});

export const setSalonNoshowOrDeposit = (data, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `settings/toggle/salon/noshow/deposits/${salonId}/`,
    authenticated: true,
    params: data,
    types: [SET_NOSHOW_OR_DEPOSIT_REQUEST, SET_NOSHOW_OR_DEPOSIT_SUCCESS, SET_NOSHOW_OR_DEPOSIT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    },
  },
});

export const getSalonOnStripeDashboard = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `ncob/checkout/salon/stripe/dashboard/${salonId}/`,
    authenticated: true,
    types: [GET_SALON_STRIPE_DASHBOARD_REQUEST, GET_SALON_STRIPE_DASHBOARD_SUCCESS, GET_SALON_STRIPE_DASHBOARD_FAILURE],
  },
});
